export const onboardingTypes = {
  GET_ONBOARDING: "LEARNER_GET_ONBOARDING",
  SET_ONBOARDING: "LEARNER_SET_ONBOARDING",
  GET_SINGLE_ONBOARDING: "LEARNER_GET_SINGLE_ONBOARDING",
  SET_SINGLE_ONBOARDING: "LEARNER_SET_SINGLE_ONBOARDING",
};

export const getOnboarding = () => ({
  type: onboardingTypes.GET_ONBOARDING,
});

export const setOnboarding = (payload: any) => ({
  type: onboardingTypes.SET_ONBOARDING,
  payload,
});

export const getSingleOnboarding = (id: string) => ({
  type: onboardingTypes.GET_SINGLE_ONBOARDING,
  payload: id,
});

export const setSingleOnboarding = (payload: any) => ({
  type: onboardingTypes.SET_SINGLE_ONBOARDING,
  payload,
});
